import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag, ArrowRight } from "lucide-react";
import { useCart } from "../context/CartContext";
import { imgUrl, eur } from "../lib/api";

export default function Cart() {
  const { items, updateQty, removeItem, subtotal } = useCart();
  const nav = useNavigate();

  if (items.length === 0) return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center">
      <ShoppingBag className="h-14 w-14 text-[#1E3A2F]/30 mx-auto mb-5" />
      <h1 className="font-serif-display text-3xl text-[#1E3A2F]">Το καλάθι σας είναι άδειο</h1>
      <p className="text-[#536D61] mt-2">Προσθέστε προϊόντα για να συνεχίσετε.</p>
      <Link to="/shop" className="mt-6 inline-flex items-center gap-2 bg-[#1E3A2F] text-white px-7 py-3.5 rounded-sm hover:bg-[#111C18]">
        Δείτε τα προϊόντα <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
      <h1 className="font-serif-display text-4xl text-[#1E3A2F] mb-8">Καλάθι αγορών</h1>
      <div className="grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-4">
          {items.map((it) => (
            <div key={it.product_id} className="flex gap-4 bg-white border border-[#E5E9E4] rounded-sm p-4" data-testid={`cart-item-${it.product_id}`}>
              <Link to={`/product/${it.product_id}`} className="h-24 w-24 shrink-0 rounded-sm overflow-hidden bg-[#E8F0E1]">
                {it.image ? <img src={imgUrl(it.image)} alt={it.name} className="h-full w-full object-cover" /> : null}
              </Link>
              <div className="flex-1 min-w-0">
                <Link to={`/product/${it.product_id}`} className="font-medium text-[#1E3A2F] hover:underline line-clamp-2">{it.name}</Link>
                <p className="text-sm text-[#536D61] mt-1">{eur(it.price)}</p>
                <div className="mt-3 flex items-center justify-between">
                  <div className="flex items-center border border-[#E5E9E4] rounded-sm">
                    <button onClick={() => updateQty(it.product_id, it.quantity - 1)} className="p-2 hover:bg-[#E8F0E1]"><Minus className="h-3.5 w-3.5" /></button>
                    <span className="w-9 text-center text-sm">{it.quantity}</span>
                    <button onClick={() => updateQty(it.product_id, it.quantity + 1)} className="p-2 hover:bg-[#E8F0E1]"><Plus className="h-3.5 w-3.5" /></button>
                  </div>
                  <button onClick={() => removeItem(it.product_id)} className="text-[#C25953] hover:text-[#a3433d] p-2" data-testid={`remove-${it.product_id}`}><Trash2 className="h-4 w-4" /></button>
                </div>
              </div>
              <div className="text-right font-semibold text-[#1E3A2F] whitespace-nowrap">{eur(it.price * it.quantity)}</div>
            </div>
          ))}
        </div>

        <div className="lg:col-span-1">
          <div className="bg-white border border-[#E5E9E4] rounded-sm p-6 sticky top-28">
            <h2 className="font-serif-display text-2xl text-[#1E3A2F] mb-4">Σύνοψη</h2>
            <div className="flex justify-between text-sm py-2"><span className="text-[#536D61]">Υποσύνολο</span><span className="font-medium">{eur(subtotal)}</span></div>
            <div className="flex justify-between text-sm py-2 border-b border-[#E5E9E4]"><span className="text-[#536D61]">Μεταφορικά</span><span className="text-[#536D61]">Υπολογίζονται στο ταμείο</span></div>
            <div className="flex justify-between py-4 text-lg font-semibold text-[#1E3A2F]"><span>Σύνολο</span><span data-testid="cart-subtotal">{eur(subtotal)}</span></div>
            <button onClick={() => nav("/checkout")} data-testid="checkout-button" className="w-full bg-[#1E3A2F] text-white py-3.5 rounded-sm font-medium hover:bg-[#111C18] transition-colors">
              Ολοκλήρωση αγοράς
            </button>
            <Link to="/shop" className="block text-center text-sm text-[#536D61] hover:text-[#1E3A2F] mt-4">Συνέχεια αγορών</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
